/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type ReportsFindCoordinatesStatusItem =
  (typeof ReportsFindCoordinatesStatusItem)[keyof typeof ReportsFindCoordinatesStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesStatusItem = {
  publishedRRA: 'publishedRRA',
  pendingRRA: 'pendingRRA',
  draft: 'draft',
  published: 'published',
  incorrect: 'incorrect',
} as const;
